import { useEffect, useState } from 'react';
import css from './PartnersSection.module.css';
import PARTNERS_FALLBACK from './partnersConfig';

const PartnerLogo = ({ partner }) => {
  return (
    <a
      href={partner.href}
      className={css.logoItem}
      target="_blank"
      rel="noopener noreferrer"
      title={partner.name}
    >
      {partner.logo && (
        <img src={partner.logo} alt={partner.name} className={css.logoImg} />
      )}
      {partner.label && (
        <span className={css.logoText} style={partner.style || {}}>
          {partner.label}
          {partner.sublabel && <span className={css.logoSub}>{partner.sublabel}</span>}
        </span>
      )}
    </a>
  );
};

const PartnersSection = () => {
  const [partners, setPartners] = useState(PARTNERS_FALLBACK);

  useEffect(() => {
    fetch('/api/partners')
      .then(res => {
        if (!res.ok) throw new Error('Partners fetch failed');
        return res.json();
      })
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          setPartners(data);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className={css.wrapper}>
      <div className={css.container}>
        <p className={css.label}>In collaboration with</p>

        <div className={css.logosGrid}>
          {partners.map((partner, idx) => (
            <PartnerLogo key={idx} partner={partner} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnersSection;
